module.exports = __webpack_public_path__ + "img/main-bg.06704ea7.png";